import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ConfirmDialogSettings } from '@/types/ConfirmDialogSettings';
import { CONFIRM_DIALOG } from '@/utils/events';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmDialog',
  emits: [CONFIRM_DIALOG.CLICK_OK, CONFIRM_DIALOG.CLOSE],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t } = useI18n();
const emit = __emit;

let dialog = ref(false);
const DEFAULT_PARAMS = {
  cancelText: '',
  okText: '',
  title: '',
  text: ''
};
const dialogSettings = ref(DEFAULT_PARAMS);

function open(settings: ConfirmDialogSettings) {
  dialogSettings.value.cancelText = settings?.cancelText ?? t('Button.Cancel');
  dialogSettings.value.okText = settings?.okText ?? t('Button.Ok');
  dialogSettings.value.title = settings?.title ?? t('ConfirmDialog.Title');
  dialogSettings.value.text = settings?.text ?? t('ConfirmDialog.Text');
  dialog.value = true;
}

function close() {
  dialog.value = false;
  dialogSettings.value = DEFAULT_PARAMS;
  emit(CONFIRM_DIALOG.CLOSE);
}

function clickOk(){
  emit(CONFIRM_DIALOG.CLICK_OK);
  close();
}
__expose({ open, close });

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _unref(dialog),
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(dialog) ? (dialog).value = $event : dialog = $event)),
    persistent: "",
    width: "400"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(dialogSettings.value.title), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(dialogSettings.value.text), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "error",
                variant: "text",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(dialog) //@ts-ignore
 ? dialog.value = false : dialog = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(dialogSettings.value.cancelText), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "text",
                onClick: clickOk
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(dialogSettings.value.okText), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})